<script setup>
import { CheckBadgeIcon } from "@heroicons/vue/24/solid";
defineProps({
  accepted: Boolean,
  locked: Boolean,
  busy: Boolean,
  disabled: Boolean,
});
defineEmits(["accept"]);
</script>

<template>
  <button
    class="btn accent rounded"
    type="button"
    :disabled="disabled || locked || busy"
    :title="locked ? 'This quote is accepted. Unlock it to make changes.' : 'Accept the current quote details'"
    @click.prevent="$emit('accept')"
  >
    <CheckBadgeIcon class="icon" />
    {{ busy ? "Accepting..." : accepted && locked ? "Accepted" : accepted ? "Accept Changes" : "Accept Quote" }}
  </button>
</template>
